module.exports = __webpack_public_path__ + "img/company-turkey-breast.58a202e9.jpg";